import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


//import { PreBootService } from '../services/preboot.service'
import { NavigationService } from '../services/navigation.service'

import { environment } from '../../environments/environment';

import { AuthenticationService } from '../services/authentication.service'
import { MenuService } from '../services/menu.service'
import { AuthWebService } from 'app/services/authweb.service';
import { HttpClient } from '@angular/common/http';

@Component ({
    selector: 'app-menu',
    templateUrl: 'menu.component.html',
    styleUrls: ['menu.component.css'],
    providers: []
})
export class MenuComponent implements OnInit {

    public ParentItems : any = [];
    public ChildItems: any = [];
    public hasAdmin: boolean;
  
  private subMenuCache: any = {};
    //public authentication;
    public loggedInUser;
    public UserData: any = [];


  constructor(public authentication: AuthWebService,
                private navService: NavigationService, 
                private auth: AuthenticationService,                
                private menu: MenuService,
                private router: Router,
                private http: HttpClient ) {

           // this.authentication = auth;
           
    this.UserData = environment.authWebApi.userData;
    console.log(this.UserData);
            if(this.UserData != null){
                this.sortMenu(this.UserData)
            }
     }

    ngOnInit() {
     
    }

    hasChildren(parent){

        if(this.ChildItems.some(x => x.MainMenuID === parent.ID))
            return true
    }


    sortMenu(data){     

        if(data.MainMenus.length > 0){

            let count = data.MainMenus.length;

            for (let i = 0; i < count; i++) {

                this.ParentItems.push(data.MainMenus[i])
            }
    
            let Ccount = data.SubMenus.length;        
  
            for (let i = 0; i < Ccount; i++) {
                
                    if(data.SubMenus[i].MenuItemYN == true)
                    {
                        this.ChildItems.push(data.SubMenus[i])
                    }
            }
    
        }
       
    }


  subMenus(mainMenu) {

      // data.forEach(element => {
      //   if(element.CODE == 'ADMIN'){
      //     this.hasAdmin = true;
      //   }
      // });
  
      ////console.log(mainMenu)

    if (!this.hasAdmin) {
      if (mainMenu.Code == "ADMIN") {
        this.hasAdmin = true;
      }
    }

     

    if (typeof this.subMenuCache[mainMenu.ID] !== 'undefined') {
      return this.subMenuCache[mainMenu.ID];
    }

    if (this.authentication.userData && this.authentication.userData.SubMenus) {
      return this.subMenuCache[mainMenu.ID] = this.authentication.userData.SubMenus.filter((sm) => sm.MenuItemYN && sm.MainMenuID === mainMenu.ID);
    } else {
      return this.subMenuCache[mainMenu.ID] = [];
    }
  }

  pathFromScreenName(screenName: string) {
    let leftSideOfQuestionMark = (screenName + '').split('?', 2)[0];
    return leftSideOfQuestionMark;
  }

  queryParamsFromScreenName(screenName: string) {

    let result = {};
    let rightSideOfQuestionMark = (screenName + '').split('?', 2)[1];
    let parameters = (rightSideOfQuestionMark + '').split('&');

    for (let parameter of parameters) {
      let tokens = parameter.split('=', 2);
      result[tokens[0]] = tokens[1];
    }

    return result;
  }

  navAuthWeb(){
    const url = environment.authWebApi.client;
    window.open(url);
  }
  navSharePoint(){
    //console.log(this.UserData)
    const url = environment.authWebApi.client;
    window.open(url);
  }
}

